import React, { FC } from 'react';
import { VimEhrDisplayReLoginScreenTab, VimEhrLoginCredentialsTab } from '.';

export const LoginAccordion: FC = () => (
  <>
    <VimEhrDisplayReLoginScreenTab />
    <VimEhrLoginCredentialsTab />
  </>
);
